import { message, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { BiCopy } from "react-icons/bi";
import { Button } from "../../components/Button";
import { ExternalLogin } from "../../components/ExternalLogin";
import { Load } from "../../components/Load";
import { ModalCofirm } from "../../components/ModalCofirm";
import { PermissionComponent } from "../../components/PermissionComponent";
import { WhatsappConnection } from "../../components/WhatsappConnection";

import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { Page } from "./styles";
import { WebHook } from "../../components/WebHook";
interface UserInfo {
  id: string;
  usingExternalConnection: boolean;
}
const Configurations = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [loadingToggleExternalConnection, setLoadingToggleExternalConnection] =
    useState(false);
  const [status, setStatus] = useState(false);
  const [
    visibleModalActiveExternalConnection,
    setVisibleModalActiveExternalConnection,
  ] = useState(false);
  const [
    visibleModalLoginExternalConnection,
    setVisibleModalLoginExternalConnection,
  ] = useState(false);
  const [
    visibleModalDisableExternalConnection,
    setVisibleModalDisableExternalConnection,
  ] = useState(false);
  function fetchData() {
    api
      .get<UserInfo>("users/me")
      .then((response) => {
        const user = response.data;
        setStatus(user.usingExternalConnection);
      })
      .finally(() => setLoading(false));
  }

  function handleCopyLink() {
    navigator.clipboard
      .writeText(`${process.env.REACT_APP_API_URL}/register/${user.id}`)
      .then(() => message.success("Link copiado!"))
      .catch(() => {
        message.error("Ocorreu um erro ao copiar o link.");
      });
  }
  function handleEnableExternalConnection() {
    setStatus(true)
    handleCloseLoginExternalConnection()
  }
  function handleDisableExternalConnection() {
    setLoadingToggleExternalConnection(true);
    api
      .put("/users/externalconnection")
      .then(() => {
        setStatus(false);
        handleCloseDisableExternalConnection();
        message.success("Conexão externa alterada.");
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoadingToggleExternalConnection(false));
  }
  function handleOpenEnableExternalConnection() {
    setVisibleModalActiveExternalConnection(true);
  }
  function handleOpenDisableExternalConnection() {
    setVisibleModalDisableExternalConnection(true);
  }
  function handleCloseEnableExternalConnection() {
    setVisibleModalActiveExternalConnection(false);
  }
  function handleCloseDisableExternalConnection() {
    setVisibleModalDisableExternalConnection(false);
  }
  function handleCloseLoginExternalConnection() {
    setVisibleModalLoginExternalConnection(false);
    setLoadingToggleExternalConnection(false);
  }
  function handleOpenLoginExternalConnection() {
    handleCloseEnableExternalConnection()
    return setVisibleModalLoginExternalConnection(true);
  }

  function handleToggleStatus() {
    if (status) {
      handleOpenDisableExternalConnection();
    } else {
      handleOpenEnableExternalConnection();
    }
  }
  useEffect(fetchData, []);
  return (
    <Page>
      {visibleModalActiveExternalConnection && (
        <ModalCofirm
          cancel={handleCloseEnableExternalConnection}
          confirm={handleOpenLoginExternalConnection}
          title={"Tem certeza que deseja usar a conexão externa PipeGo?"}
          description={
            "É necessário que o whatsapp esteja vinculado na plataforma PipeGo CRM e um login e senha precisa ser fornecido."
          }
          loading={loadingToggleExternalConnection}
        />
      )}
      {visibleModalLoginExternalConnection && (
        <ExternalLogin
          cancel={handleCloseLoginExternalConnection}
          confirm={handleEnableExternalConnection}
          title={"Login externo"}
          description={
            "É necessário fornecer um email e senha válidos da plataforma PipeGo."
          }
        />
      )}
      {visibleModalDisableExternalConnection && (
        <ModalCofirm
          cancel={handleCloseDisableExternalConnection}
          confirm={handleDisableExternalConnection}
          title={"Tem certeza que deseja desabilitar a conexão externa PipeGo?"}
          description={
            "Todo o envio de mensagens será feito pela conexão realizada nessa plataforma."
          }
          loading={loadingToggleExternalConnection}
        />
      )}

      <header>
        <span>Configurações</span>
      </header>
      <div className="content">
        <div className="header-conf">
          <span>Conexão Externa</span>
        </div>
        {loading ? (
          <Load />
        ) : (
          <div className="main-content">
            <h2>Usar a conexão do PipeGo como principal?</h2>
            <Switch
              checkedChildren="SIM"
              unCheckedChildren="NÃO"
              defaultChecked={status}
              checked={status}
              onChange={handleToggleStatus}
              style={{ borderRadius: "8px" }}
            />
          </div>
        )}
      </div>
      {
        !status && <WhatsappConnection />
      }

      <PermissionComponent type="USER" caseType={2}>
        <div className="content">
          <div className="header-conf">
            <span>
              Link de contrato <BiCopy />
            </span>
          </div>
          <div className="main-content">
            <span>
              {process.env.REACT_APP_API_URL}/register/{user.id}
            </span>
            <Button title="Copiar Link" onClick={handleCopyLink} />
          </div>
        </div>
      </PermissionComponent>
      <WebHook />
    </Page>
  );
};
export { Configurations };
